<template>
    <div>
        <div v-show="format == 'small'">
            <!-- Toggle tableau / graphique -->
            <div v-if="chart_enable && chart_rows.length > 0" class="array-view-toggle">
                <b-button-group size="sm">
                    <b-button :variant="view_mode === 'table' ? 'primary' : 'outline-secondary'" @click="view_mode = 'table'">
                        <i class="fas fa-table"></i> Tableau
                    </b-button>
                    <b-button :variant="view_mode === 'chart' ? 'primary' : 'outline-secondary'" @click="view_mode = 'chart'">
                        <i class="fas fa-chart-pie"></i> Graphique
                    </b-button>
                </b-button-group>
            </div>
            <!-- Tabulator : toujours dans le DOM, masqué sans display:none quand graphique actif -->
            <div :class="{ 'array-hidden-no-display': chart_enable && view_mode === 'chart' }">
                <edit_tabulator @data_length="set_data_length" @update_cell="update_cell" :_index="index" :row_updates="false" ref="tabulator" :categories="categories" :categories_splash="categories_splash" :extern_file="false" :columns_type="columns_type"></edit_tabulator>
            </div>
            <!-- Graphiques -->
            <div v-if="chart_enable && view_mode === 'chart' && chart_rows.length > 0">
                <template v-if="chart_configs.length > 1">
                    <b-tabs content-class="pt-2">
                        <b-tab v-for="(cfg, i) in chart_configs" :key="i" :title="cfg.title || ('Graphique ' + (i + 1))">
                            <chart-display :rows="chart_rows" :config="cfg" :editable="false" />
                        </b-tab>
                    </b-tabs>
                </template>
                <chart-display v-else-if="chart_configs.length > 0" :rows="chart_rows" :config="chart_configs[0]" :editable="false" />
            </div>
            <span v-for="(action, idx) in actions" :key="idx">
                <action :ref="'action_' + idx" :idx_action="idx" :test="true" :index="index" :data="data" @launch_treatment="launch_treatment" :columns="data.length == 0 ? [] : Object.keys(data[0])" :nb="nb" :source_data="get_data" :action="action"></action>&nbsp;
            </span>
            <div v-if="action_columns[block_i + ' ' + block_j] && action_columns[block_i + ' ' + block_j].length > 0 && format == 'small'">
                <b-button variant="link" @click="line_idx--" v-if="line_idx > 0">&lt;</b-button>
                Ligne {{data[line_idx][index]}}
                <b-button variant="link" @click="line_idx++" v-if="line_idx + 1 < data.length">&gt;</b-button>
                <c_action_columns 
                    v-if="view_c_action_columns" 
                    @update_actions_column_mapping="update_actions_column_mapping(block_i, block_j, ...arguments)" 
                    @update_obj="update_obj(data[line_idx][index], ...arguments)"  
                    @update="update_cell(data[line_idx][index], ...arguments)" 
                    :data="data[line_idx]" 
                    :action_columns="action_columns[block_i + ' ' + block_j]" 
                    :block_i="block_i" 
                    :block_j="block_j"
                    :index="index"
                    :action_columns_picking="action_columns_picking"
                ></c_action_columns>
            </div>
        </div>
        <div v-show="format == 'big' || format == 'one'">
            <div v-show="format == 'big'">
                <b-button v-show="start > 0" variant="link" @click="start -= 10">&lt;</b-button> Page {{(start / 10) + 1}}
                <b-button v-show="(start + 10) < data.length" variant="link" @click="start += 10">></b-button>
            </div>
            <b-card style="width:100%; padding:0px" v-for="(line, idx) in data.slice(start, start + 10)" :key="idx">
                <b-container style="margin: 0; padding: 0; max-width: none">
                    <b-row>
                        <b-col :cols="column.size || 12" v-for="(column, idx_column) in columns_type" :key="idx_column">
                            <div v-if="column.type == 'text'">
                                <div v-if="column.text_type == 'textarea'">
                                    <div v-if="column.edit == true">
                                        <p>{{column.column}}
                                            <b-textarea :rows="10" @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" />
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p>{{column.column}}</p>
                                        <p>{{line[column.column]}}</p>
                                    </div>
                                </div>
                                <div v-else-if="column.text_type == 'json'">
                                    <div v-if="column.edit == true">
                                        <p>{{column.column}}
                                            <ace_editor :height="column.size ? 800 : 500" @update="update_cell_json($event, line[index], column.column)" mode="json" :code="JSON.stringify(JSON.parse(line[column.column]), null, '   ')"></ace_editor>
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p>{{column.column}}</p>
                                        <p style="white-space: pre">{{line[column.column] ? JSON.stringify(JSON.parse(line[column.column]), null, "    ") : ""}}</p>
                                    </div>
                                </div>
                                <div v-else-if="column.text_type == 'html'">
                                    <div v-if="column.edit == true">
                                        {{column.column}}
                                        <b-container style="margin: 0; padding: 0; max-width: none">
                                            <b-row style="margin-bottom:10px">
                                                <b-col cols="6">
                                                    <b-textarea style="height:90%;" v-model="line[column.column]"></b-textarea>
                                                </b-col>
                                                <b-col>
                                                    <div v-html="line[column.column]"></div>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </div>
                                    <div v-else>
                                        <p>{{column.column}}</p>
                                        <p v-html="line[column.column]"></p>
                                    </div>
                                </div>
                                <div v-else-if="column.text_type == 'url'">
                                    <div v-if="column.edit == true">
                                        <p>{{column.column}} <a target="_blank" :href="line[column.column]"><i class="fas fa-eye"></i></a>
                                            <b-input @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" />
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p>{{column.column}} : <a target="_blank" :href="line[column.column]">{{line[column.column]}}</a></p>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="column.edit == true">
                                        <p>{{column.column}}
                                            <b-input @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" />
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p>{{column.column}} : {{line[column.column]}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="column.type == 'list'">
                                <div v-if="column.edit == true">
                                    <p>{{column.column}}
                                        <b-select @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" :options="column.params.editorParams.values" />
                                    </p>
                                </div>
                                <div v-else>
                                    <p>{{column.column}} : {{line[column.column]}}</p>
                                </div>
                            </div>
                            <div v-else-if="column.type == 'list_db'">
                                <div v-if="column.edit == true">
                                    <p>{{column.column}}</p>
                                    <select_db :config="column.params" :index="idx + start" @update="update_cell" :column="column.column" :start_value="line[column.column]" :id_index="data[line_idx][index]" />
                                </div>
                                <div v-else>
                                    <p>{{column.column}} : {{line[column.column]}}</p>
                                </div>
                            </div>
                            <div v-else-if="column.type == 'boolean'">
                                <div v-if="column.edit == true">
                                    <p>{{column.column}}
                                        <b-checkbox @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" value="1" unchecked-value="0" />
                                    </p>
                                </div>
                                <div v-else>
                                    <p>{{column.column}} : {{line[column.column]}}</p>
                                </div>
                            </div>
                            <div v-else-if="column.type == 'image'">
                                <div v-if="column.uniq">
                                    <div v-if="column.edit == true">
                                        <p>{{column.column}}
                                            <b-input @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" />
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p>{{column.column}} : {{line[column.column]}}</p>
                                    </div>
                                    <viewFile :getDownload="false" :showFileName="false" :data="line[column.column]" type="image" :resize_image="column.resize_image"></viewFile>
                                </div>
                                <div v-else>
                                    <p>{{column.column || idx_column}}</p>
                                    <images :index="idx + start" @update="update_cell" :edit="column.edit" :black_white_lists="column.black_white_lists || false" :black_white_lists_edit="column.black_white_lists_edit || false" :splash="column.splash || false" :column="column.column || idx_column" :source="line[column.column || idx_column]" :tabulator="false"></images>
                                    <br />
                                </div>
                            </div>
                            <div v-else-if="column.type == 'video'">
                                <p>{{column.column}}</p>
                                <videos :index="idx + start" @update="update_cell" :edit="column.edit" :black_white_lists="column.black_white_lists || false" :black_white_lists_edit="column.black_white_lists_edit || false" :column="column.column" :source="line[column.column]" :tabulator="false"></videos>
                                <br />
                            </div>
                            <div v-else-if="column.type == 'category'">
                                <p>{{column.column}}</p>
                                <categories @update="update_cell" :column="column.column" :index="idx + start" :edit="column.edit" :categories_prop="categories" :source="line[column.column]" :tabulator="false"></categories>
                                <br />
                            </div>
                            <div v-else-if="column.type == 'category_splash'">
                                <p>{{column.column}}</p>
                                <categories_splash @update="update_cell" :column="column.column" :index="idx + start" :edit="column.edit" :categories_prop="categories_splash" :source="line[column.column]" :tabulator="false" :params="column.params"></categories_splash>
                                <br />
                            </div>
                            <div v-else-if="column.type == 'file'">
                                <viewFile :getDownload="false" :showFileName="false" :data="line[column.column]"></viewFile>
                                <br />
                            </div>
                            <div v-else-if="column.type == 'file_zoom'">
                                <viewFileZoom :showFileName="false" :data="line[column.column]"></viewFileZoom>
                                <br />
                            </div>
                            <div v-else-if="column.type == 'url'">
                                <div v-if="column.edit == true">
                                    <p>{{column.column}}
                                        <b-input @change="update_cell(line[index], column.column, line[column.column])" v-model="line[column.column]" />
                                    </p>
                                </div>
                                <div v-else>
                                    <p>{{column.column}} : {{line[column.column]}}</p>
                                </div>
			                    <iframe height="500px" width="100%" :src="line[column.column]" sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"></iframe>
                            </div>
                            <div v-else>
                                {{column.column}} : {{line[column.column]}}
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
                <span v-for="(action, idx_action) in actions" :key="'a' + idx_action">
                    <action :ref="'action_' + idx_action" :idx_action="idx_action" :index="index" :data="[line]" @launch_treatment="launch_treatment" :columns="data.length == 0 ? [] : Object.keys(data[0])" :source_data="get_data" :action="action" :idx="idx"></action>&nbsp;
                </span>
                <div v-if="action_columns[block_i + ' ' + block_j] && action_columns[block_i + ' ' + block_j].length > 0">
                    <c_action_columns 
                        @update_actions_column_mapping="update_actions_column_mapping(block_i, block_j, ...arguments)" 
                        @update_obj="update_obj(line[index], ...arguments)" 
                        @update="update_cell(line[index], ...arguments)" 
                        :data="line"
                        :index="index" 
                        :action_columns="action_columns[block_i + ' ' + block_j]" 
                        :block_i="block_i" 
                        :block_j="block_j"
                        :action_columns_picking="action_columns_picking"
                    ></c_action_columns>
                </div>
            </b-card>
            <div v-if="format == 'big' && actions && actions.length > 0">
                <p>Toute la page<br />
                    <span v-for="(action, idx_action) in actions" :key="'b' + idx_action">
                        <action :ref="'action_' + idx_action" :idx_action="idx_action" :index="index" :data="data" @launch_treatment="launch_treatment" :columns="data.length == 0 ? [] : Object.keys(data[0])" :source_data="get_data" :action="action" :idx="'page'" :visible="false"></action>&nbsp;
                    </span>
                </p>
                <p>Toutes les lignes<br />
                    <span v-for="(action, idx_action) in actions" :key="'c' + idx_action">
                        <action :ref="'action_' + idx_action" :idx_action="idx_action" :index="index" :data="data" @launch_treatment="launch_treatment" :columns="data.length == 0 ? [] : Object.keys(data[0])" :nb="data.length" :source_data="get_data" :action="action" :idx="'all'" :visible="false"></action>&nbsp;
                    </span>
                </p>
            </div>
        </div>
    </div>

</template>

<script>
    import _ from 'lodash';
    
    import categories_splash from '../categories_splash.vue';   
    import c_action_columns from "./action_columns.vue";
    import edit_tabulator from "../edit_tabulator.vue";
    import ChartDisplay from "../ChartDisplay.vue";
    import database from "../../services/database.js";
	import viewFileZoom from "../viewFileZoom.vue";
    import select_db from "../select_db.vue";
    import ace_editor from "../ace_editor";
	import viewFile from "../viewFile.vue";
    import categories from "../categories";
    import store from "../../store";
    import images from "../images";
	import videos from "../videos";
    import action from "./action";

    var clone = require("clone");
    
    export default {
        name: "array",
		components: {
            select_db,
            viewFileZoom,
            c_action_columns,
            ace_editor,
            edit_tabulator,            ChartDisplay,            images,
            videos,
            categories,
            categories_splash,
            viewFile,
            action
        },
        props: {
            format: {
                default: "small"
            },
            index: {},
            action_columns: {
                default: () => {}
            },
            action_columns_picking : {
                default: () => {}
            },
            tabulator_columns_type : {
                default: () => {}
            }
        },
        watch:
        {
            action_columns_picking: {
                deep: true,
                async handler() {
                    console.log("action_columns_picking")
                }            
            },
            tabulator_columns_type: {
                deep: true, 
                immediate: true,
                async handler() {
                    this.columns_type = {...this.columns_type, ...this.tabulator_columns_type}
                }     
            }
        },
        data: function () {
            return {
                data: [],
                categories: null,
                categories_splash: null,
                columns_type: {},
                all_columns: false,
                all_columns_no_edit: false,
                start: 0,
                actions: [],
                nb: 0,
                change_to_apply: {},
                line_idx: 0,
                block_i: 0,
                block_j: 0,
                view_c_action_columns: true,
                chart_enable: false,
                chart_configs: [],
                view_mode: 'table',
                chart_rows: []
            };
		},
		methods: {
            getStart()
            {
                return this.start;
            },
            async update_param(key, value)
            {
                console.log("update_param")
                var self = this;

                for (var i = 0; i < self.actions.length; i++)
                {
                    for (var j = 0; j < self.$refs['action_' + i].length; j++)
                    {
                        self.$refs['action_' + i][j].update_param(key, value)
                    }
                }
            },
            update_actions_column_mapping(block_i, block_j, idx, mapping_column, old_mapping_column)
            {
                console.log("update_actions_column_mapping")
                this.$emit("update_actions_column_mapping", block_i, block_j, idx, mapping_column, old_mapping_column)
            },
            update_obj(index, mapping, idx_json_value, id_json, id_action_column, idx_action_column, data, multiple)
            {
                this.$emit("update_data_picking", this.index, index, mapping, idx_json_value, id_json, id_action_column, idx_action_column, data, multiple)
            },
            set_action(action, idx, block_i, block_j)
            {
                console.log("set_action")
                var self = this;

                if (block_i == this.block_i && block_j == this.block_j)
                {
                    this.actions[idx] = action;
                    for (var i = 0; i < self.$refs['action_' + idx].length; i++)
                    {
                        self.$refs['action_' + idx][i].update_action(action);
                    }
                }
            },
            set_data_length(nb)
            {
                this.nb = nb;
            },
            launch_treatment(id, action, data, idx_action, treatment_params)
            {
                this.$emit("launch_treatment", id, action, data, idx_action, treatment_params, this.block_i, this.block_j);
            },
            get_data(idx = 0)
            {
                //console.log("get data " + idx)
                if (this.format == 'big')
                {
                    if (idx == 'page')
                        return this.data.slice(this.start, this.start + 10);    
                    if (idx == "all")
                        return this.data;
                    return [this.data[this.start + idx]];
                }
                else if (this.format == "small")
                {
                    return this.$refs.tabulator.get_data();
                }
                else
                    return this.data;
            },
            async set_data_cell(index, column, data, apply)
            {
                var self = this;
                if (apply)
                {
                    var match = this.data.filter(x => {return x[self.index] === index })
                    if (match.length > 0)
                        this.$set(match[0], column, data);
                }
                else
                {
                    if(!this.change_to_apply[index])
                        this.change_to_apply[index] = {};
                    this.change_to_apply[index][column] = data;
                }
                this.$refs.tabulator.set_data_cell(index, column, data, apply);
            },
            async set_data_cell_apply(action, columns = [])
            {
                var self = this;
                //console.log('array set_data_cell_apply')
                this.$refs.tabulator.set_data_cell_apply(this.all_columns ? true : false);
                for (var i = 0; i < this.data.length; i++)
                {
                    if (this.change_to_apply[this.data[i][this.index]])
                    {
                        var keys = Object.keys(this.change_to_apply[this.data[i][this.index]]);
                        for (var j = 0; j < keys.length; j++)
                        {
                            this.$set(this.data[i], keys[j], this.change_to_apply[this.data[i][this.index]][keys[j]]);
                        }
                    }
                }
                this.change_to_apply = {};

                var _line_idx = this.line_idx;
                this.view_c_action_columns = false;
                this.$nextTick(async function () {
                  self.view_c_action_columns = true;
                });
                console.log('array set_data_cell_apply - end')
            },
            async update_cell(index, column, data)
            {
                if (typeof index == "number")
                    index = this.data[index][this.index];
                //console.log("array - update_cell - " + index)
                this.$emit("update_cell", index, column, data);
            },
            async update_cell_json(data, index, column)
            {
                if (!data)
                    return;
                try {
                    data = JSON.stringify(JSON.parse(data));
                }
                catch (err)
                {
                    return;
                }
                if (typeof index == "number")
                    index = this.data[index][this.index];
                //console.log("array - update_cell component - " + index)
                this.$emit("update_cell", index, column, data);
            },
            async load(data)
            {
                data = clone(data);

                if (data.length == 0)
                    return;
                
                this.all_columns = data.all_columns || false;
                this.all_columns_no_edit = data.all_columns_no_edit || false;
                this.columns_type = {}
                this.block_i = data.block_i;
                this.block_j = data.block_j;
                
                if (data.columns_type)
                {
                    this.columns_type_arr = data.columns_type;
                    for (var i = 0; i < data.columns_type.length; i++)
                    {
                        this.columns_type[data.columns_type[i].column] = data.columns_type[i];
                        if (this.columns_type_arr[i] && this.columns_type_arr[i].type == "category" && !this.categories && store.state.client.details.tables_obj)
                        {
                            /*this.categories = await database.get("select", store.state.client.details.tables_obj.categories, {
                                select: "*",
                                where: "level is not null order by level"
                            });*/
                        }
                        if (this.columns_type_arr[i] && this.columns_type_arr[i].type == "category_splash" && !this.categories_splash)
                        {
                            this.categories_splash = await database.get("select", "categories", {
                                select: "*",
                            });
                        }
                    }
                }

                if (this.tabulator_columns_type)
                    this.columns_type = {...this.columns_type, ...this.tabulator_columns_type}

                this.chart_enable = data.chart_enable || false;
                this.chart_configs = data.chart_configs || [];

                this.actions = data.actions ? data.actions.actions : [];
            },
            async load_data(data)
            {
                this.data = clone(data);
                this.chart_rows = clone(data);

                this.$refs.tabulator.set_data(this.data, this.all_columns ? (data.length > 0 ? Object.keys(data[0]) : []) : Object.keys(this.columns_type));

                if (this.all_columns === true && this.data.length > 0)
                {
                    var columns = Object.keys(data[0]);

                    for (var i = 0; i < columns.length; i++)
                    {
                        if (!this.columns_type[columns[i]])
                        {
                            var obj = {
                                type: "text",
                                edit: this.all_columns_no_edit ? false : true,
                                column: columns[i]
                            };
                            this.columns_type_arr.push(obj);
                            this.columns_type[columns[i]] = obj;
                        }
                    }
                }
            }
		},
		mounted: function () {

		},
    }


</script>

<style scoped>
.array-view-toggle {
    margin-bottom: 10px;
}
/* Masque sans display:none pour ne pas casser Tabulator.js */
.array-hidden-no-display {
    visibility: hidden;
    height: 0;
    overflow: hidden;
}
</style>